const UNITS = ['year', 'month', 'week', 'day', 'hour', 'minute', 'second'];

const is = (interval, unit) => (unit >= interval ? unit / interval : 0);

const getRoundFunction = (round) =>
	round === 'floor' ? Math.floor : Math.round;

const calculateTimeAgo = (time, relativeTime, round) => {
	const unitOfTimes = {};

	unitOfTimes.sec = (relativeTime - time) / 1000;
	unitOfTimes.min = is(60, unitOfTimes.sec);
	unitOfTimes.hour = is(60, unitOfTimes.min);
	unitOfTimes.day = is(24, unitOfTimes.hour);

	unitOfTimes.week = is(7, unitOfTimes.day);

	// Assuming the Gregorian calendar, 365.2425 days/year / 12 months/year = 30.436875 days/month.
	// Read more: https://gitlab.com/catamphetamine/javascript-time-ago/-/blob/main/source/steps/units.js
	// Read more: https://www.quora.com/What-is-the-average-number-of-days-in-a-month
	unitOfTimes.month = is(30.44, unitOfTimes.day);

	// Based on the Gregorian cycle of 400 years has exactly 146097 days
	unitOfTimes.year = is(146097 / 400, unitOfTimes.day);

	const roundFunction = getRoundFunction(round);

	const unit = UNITS.find((item) => roundFunction(unitOfTimes[item]) > 0);

	if (!unit) return [0, unit];

	const timeValue = unitOfTimes[unit];
	const value = roundFunction(timeValue);

	return [value, unit];
};

const timeAgo = (
	time,
	labels,
	{ relativeTime = Date.now(), round = 'floor' } = {}
) => {
	const [value, unit] = calculateTimeAgo(time, relativeTime, round);

	if (!unit) return labels.get('NOW');

	const timeLabel = 'TIME_UNIT_AGO'.replace(
		'UNIT',
		`${unit}${value > 1 ? 's' : ''}`.toUpperCase()
	);
	return labels.get(timeLabel).replace('{TIME}', value);
};

export default timeAgo;
